module.exports = __webpack_public_path__ + "img/stock1.c67f71d7.png";